import { render, staticRenderFns } from "./TableExpeditionsService.vue?vue&type=template&id=5842d00c&scoped=true&"
import script from "./TableExpeditionsService.vue?vue&type=script&lang=js&"
export * from "./TableExpeditionsService.vue?vue&type=script&lang=js&"
import style0 from "./TableExpeditionsService.vue?vue&type=style&index=0&id=5842d00c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5842d00c",
  null
  
)

export default component.exports